import { useEffect, useState } from "react";
import { Inbox } from "lucide-react";
import api from "../../lib/api";

export default function AdminEnquiries() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/admin/enquiries").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="admin-enquiries">
      <h1 className="font-display font-black text-3xl tracking-tight mb-2">Website Enquiries</h1>
      <p className="text-sm text-slate-500 mb-8">Contact form submissions from the marketing site.</p>

      {items === null ? (
        <div className="flex justify-center py-24"><div className="h-8 w-8 rounded-full border-2 border-sky-600 border-t-transparent animate-spin" /></div>
      ) : items.length === 0 ? (
        <div className="bg-white border border-slate-200 rounded-xl py-20 text-center" data-testid="enquiries-empty">
          <Inbox className="h-10 w-10 text-slate-300 mx-auto mb-4" />
          <p className="font-display font-bold text-xl">No enquiries yet</p>
          <p className="text-sm text-slate-500 mt-2">New contact form submissions will appear here.</p>
        </div>
      ) : (
        <div className="space-y-4" data-testid="enquiries-list">
          {items.map((e) => (
            <div key={e.id} className="bg-white border border-slate-200 rounded-xl p-6" data-testid={`enquiry-${e.id}`}>
              <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
                <div>
                  <p className="font-display font-bold text-lg">{e.name}</p>
                  <p className="text-xs text-slate-500">
                    <a href={`mailto:${e.email}`} className="text-sky-600 font-semibold hover:underline">{e.email}</a>
                    {e.clinic && ` · ${e.clinic}`}{e.country && ` · ${e.country}`}
                  </p>
                </div>
                <span className="text-xs text-slate-400">{new Date(e.created_at).toLocaleString()}</span>
              </div>
              {e.subject && <p className="text-sm font-semibold text-slate-700 mb-1">{e.subject}</p>}
              <p className="text-sm text-slate-600 leading-relaxed whitespace-pre-wrap">{e.message}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
